module.exports = "/_next/static/images/d754dc9b8646043840e09b1e6fae99b4-nubank-indoor-pool@xs-2x.jpg";